import { ISaleAdmin } from "../../../services/graphql/Sale";
import {
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Tooltip,
  Button,
} from "@chakra-ui/react";
import moment from "moment";
import { FaHome } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import { IProductAdmin } from "../../../services/graphql/Product";
import { ISaleProduct } from "../../../services/graphql/SaleProduct";
import { IShipment } from "../../../services/graphql/Shipment";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
interface ITableSales {
  dataSales: ISaleAdmin[];
  onClickViewProducts: (products: ISaleProduct[]) => void;
  onClickAddShipment: (sale_id: number) => void;
  onClickEditShipment: (shipment: IShipment | undefined) => void;
  onClickCeckStatusPay: (sale_id: number) => void;
  onClickDeleteShipment: (shipment_id: number) => void;
  loadingButtonsOp?: boolean;
}
export const TableSales = (props: ITableSales) => {
  const {
    dataSales,
    onClickViewProducts,
    onClickAddShipment,
    onClickCeckStatusPay,
    onClickEditShipment,
    onClickDeleteShipment,
    loadingButtonsOp,
  } = props;
  return (
    <>
      <TableContainer>
        <Table variant="striped" colorScheme="teal">
          <TableCaption>Todas las ventas</TableCaption>
          <Thead>
            <Tr>
              <Th>Fecha</Th>
              <Th>Nombre y apellido del cliente</Th>
              <Th>Teléfono del cliente</Th>
              <Th>Dirección</Th>
              <Th>Fecha de envío</Th>
              <Th>Estado</Th>
              <Th>Productos</Th>
              <Th isNumeric>Total</Th>
              <Th>Op.</Th>
            </Tr>
          </Thead>
          <Tbody>
            {dataSales.map((sale) => (
              <Tr>
                <Td>{moment(sale.operation_date).format("DD/MM/YYYY")}</Td>
                <Td>{`${sale.user.firstname}`}</Td>
                <Td>{sale.user.phone}</Td>
                <Td>
                  {!sale.address.floor && !sale.address.department
                    ? `${sale.address.street_name} ${sale.address.street_number}`
                    : `${sale.address.street_name} ${
                        sale.address.street_number
                      } - ${sale.address.floor || "-"} ${
                        sale.address.department || "-"
                      }`}
                </Td>
                <Td>
                  {sale.shipment
                    ? moment(sale.shipment.shipment_date).format("DD/MM/YYYY")
                    : "-"}
                </Td>
                <Td>
                  {sale.sale_status === "Success" ? (
                    <>
                      <Text fontWeight={"bold"} color={"green.400"}>
                        Aprobado
                      </Text>
                    </>
                  ) : sale.sale_status === "Pending" ? (
                    <Text fontWeight={"bold"} color={"yellow.500"}>
                      Pendiente
                    </Text>
                  ) : (
                    <Text fontWeight={"bold"} color={"red.400"}>
                      Rechazado
                    </Text>
                  )}
                </Td>
                <Td>
                  <Button
                    isLoading={loadingButtonsOp}
                    onClick={() => {
                      onClickViewProducts(sale.sale_product);
                    }}
                  >
                    Ver productos
                  </Button>
                </Td>
                <Td isNumeric>${sale.payment_total || "-"}</Td>
                <Td>
                  {sale.shipment && sale.sale_status === "Success" ? (
                    <>
                      <Tooltip
                        hasArrow
                        label="Editar fecha de envío"
                        bg="gray.300"
                        color="black"
                      >
                        <Button
                          isLoading={loadingButtonsOp}
                          onClick={() => {
                            onClickEditShipment(sale.shipment);
                          }}
                          mr={3}
                        >
                          <EditIcon />
                          <FaHome />
                        </Button>
                      </Tooltip>
                    </>
                  ) : null}
                  {sale.shipment && sale.sale_status === "Success" ? (
                    <>
                      <Tooltip
                        hasArrow
                        label="Eliminar fecha de envío"
                        bg="gray.300"
                        color="black"
                      >
                        <Button
                          isLoading={loadingButtonsOp}
                          onClick={() => {
                            if (sale.shipment)
                              onClickDeleteShipment(sale.shipment.id);
                          }}
                          mr={3}
                        >
                          <DeleteIcon />
                          <FaHome />
                        </Button>
                      </Tooltip>
                    </>
                  ) : null}
                  {!sale.shipment && sale.sale_status === "Success" ? (
                    <>
                      <Tooltip
                        hasArrow
                        label="Agregar fecha de envío"
                        bg="gray.300"
                        color="black"
                      >
                        <Button
                          isLoading={loadingButtonsOp}
                          onClick={() => {
                            onClickAddShipment(sale.id);
                          }}
                          mr={3}
                        >
                          <FaHome />
                        </Button>
                      </Tooltip>
                    </>
                  ) : null}
                  {sale.sale_status === "Pending" ? (
                    <>
                      <Tooltip
                        hasArrow
                        label="Reanalizar pago"
                        bg="gray.300"
                        color="black"
                      >
                        <Button
                          isLoading={loadingButtonsOp}
                          onClick={() => {
                            onClickCeckStatusPay(sale.id);
                          }}
                        >
                          <FiRefreshCw />
                        </Button>
                      </Tooltip>
                    </>
                  ) : null}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
